import { render, staticRenderFns } from "./OrganisationItemDelete.vue?vue&type=template&id=5bdd9d25&scoped=true"
import script from "./OrganisationItemDelete.vue?vue&type=script&lang=js"
export * from "./OrganisationItemDelete.vue?vue&type=script&lang=js"
import style0 from "./OrganisationItemDelete.vue?vue&type=style&index=0&id=5bdd9d25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd9d25",
  null
  
)

export default component.exports